import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHighcharts from '../CommonComponents/Highcharts';
import LoadingChart from '../CommonComponents/LoadingChart';
import { createCustomPropType, isUuid, isNumeric } from '../../js/app/react/validators';

class MobileHealthCareChartView extends Component {
  componentDidMount() {
    const { dataIsOutdated, hasLoaded, isPrint } = this.props;

    if ((!hasLoaded || dataIsOutdated) && !isPrint) {
      const {
        clientId, fpId, getChartData, goalId, isPdf,
      } = this.props;
      getChartData(fpId, clientId, isPdf, goalId);
    }
  }

  render() {
    const { chartData, hasLoaded } = this.props;

    return (
      <section>
        <div
          className="
          healthcare-chart-container
          NewFinancialPlan_ProgressChart
          NewFinancialPlan_HealthCareProgressChart"
        >
          {!hasLoaded && <LoadingChart />}
          {hasLoaded && (
            <ReactHighcharts autoResize container="HealthCareContainer" options={chartData} />
          )}
        </div>
      </section>
    );
  }
}

MobileHealthCareChartView.defaultProps = {
  isPdf: false,
  isPrint: false,
};

MobileHealthCareChartView.propTypes = {
  chartData: PropTypes.shape({}).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  dataIsOutdated: PropTypes.bool.isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  getChartData: PropTypes.func.isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  isPdf: PropTypes.bool,
  isPrint: PropTypes.bool,
};

export default MobileHealthCareChartView;
